import React from 'react'
import PropTypes from 'prop-types'

import LinearProgressTable from 'components/LinearProgressTable/LinearProgressTable'
import helpers from 'helpers'

const ProcessRiskTable = ({ processStats, ...rest }) => {
  const totalRisks =
    processStats?.departments?.reduce(
      (total, dept) => total + (dept.totalRisks || 0),
      0,
    ) || 0

  const riskCounts = helpers.myLgpd.processRiskCounts(processStats)

  const percentage = (count) => (count / totalRisks) * 100

  const rows = Object.entries(riskCounts).map(([name, value]) => ({
    name,
    value,
    percentage: percentage(value),
  }))

  return (
    <>
      <LinearProgressTable
        rows={rows}
        title="Processos por risco"
        tableType="process"
        {...rest}
      />
    </>
  )
}

ProcessRiskTable.propTypes = {
  processStats: PropTypes.object.isRequired,
}

export default ProcessRiskTable
